import { render } from "./Facilities.vue?vue&type=template&id=147318a3"
import script from "./Facilities.vue?vue&type=script&lang=js"
export * from "./Facilities.vue?vue&type=script&lang=js"

import "./Facilities.vue?vue&type=style&index=0&id=147318a3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__